import { Component, OnInit, ViewChild, EventEmitter, Input, Output } from '@angular/core';
import { FormGroup, Validators, FormBuilder } from '@angular/forms';
import { ModalDirective } from 'ng-uikit-pro-standard/lib/free/modals/modal.directive';
import { SecurityService } from 'src/app/shared/services/security.service';
import { RutService } from 'src/app/shared/services/rut.service';
import { v4 as uuidv4 } from 'uuid';
import { ConsoleService } from 'src/app/shared/services/console.service';
import { PaginationContext } from 'src/app/shared/object/pagination_context.model';
import { QueryResult } from 'src/app/shared/object/queryResult.model';
import { ClienteProveedorService } from 'src/app/services/cliente-proveedor.service';
import { FormValidatorsService } from 'src/app/shared/services/form-validators.service';
import { ToastService } from 'ng-uikit-pro-standard';
import { MessageRendererService } from 'src/app/services/message-renderer.service';
import * as _ from 'lodash'
import { VendedorService } from 'src/app/services/vendedor.service';

enum QUERY_TYPE {
  RUT_SUCURSAL = 'RUT_SUCURSAL',
  ONLY_RUT = 'ONLY_RUT',
  VENDEDOR = 'VENDEDOR',
  CLIENTE_CON_DEUDA = 'CLIENTE_CON_DEUDA',
  ONLY_RUT_BLO_DESB = 'ONLY_RUT_BLO_DESB',

}

export interface IModalSeleccionaClienteConfig {
  paginateLocally?: boolean
  allowUncheckSelected?: boolean
}

@Component({
  selector: 'app-seleccionar-vendedor',
  templateUrl: './seleccionar-vendedor.component.html',
  styleUrls: ['./seleccionar-vendedor.component.scss'],
  providers: [SecurityService],
})
export class SeleccionarVendedorComponent implements OnInit {

  hideElement: boolean = true;

  mode: 'SEARCH' | 'VIEW_SELECTED' = 'SEARCH'

  idRadioBuscarPorNombre = uuidv4()
  idRadioBuscarPorRut = uuidv4()

  // Modales
  @ViewChild('seleccionarCliente', { static: true })
  seleccionarClienteModal: ModalDirective;

  // Form
  formData: FormGroup

  // Constants
  readonly TIPO_NOMBRE: String = `_NAME_`
  readonly TIPO_RUT: String = `_RUT_`

  // Data
  private rutEmpresa: number
  private sucursalCodigo: number
  data: Array<any> = []
  dataAll: Array<any> = []
  loading: boolean = false
  dataSeleccionadaAll: Array<any> = []
  dataSeleccionada: Array<any> = []
  paginationContext: PaginationContext = new PaginationContext()
  busquedaIniciada: boolean = false
  onlyRut: Boolean = false
  allChecked: boolean = false
  defaultConfig = {
    paginateLocally: false,
    allowUncheckSelected: false
  }
  config: IModalSeleccionaClienteConfig = this.defaultConfig

  // Output
  @Output() onSelectMultiple: EventEmitter<any> = new EventEmitter<any>();
  @Output() onSelectSingle: EventEmitter<any> = new EventEmitter<any>();
  @Output() onRemoteQuery: EventEmitter<any> = new EventEmitter<any>();
  @Output() onNotFound: EventEmitter<any> = new EventEmitter<any>();

  // Input
  @Input() multiple: Boolean = true
  @Input() origen: String = null
  // @Input() onlyRut: Boolean = false
  @Input() queryType: QUERY_TYPE = QUERY_TYPE.RUT_SUCURSAL
  @Input() vendedorCodigo: any = null
  @Input() showInfoClienteInactivoBloqueado: boolean = false

  // Utils
  private log: any

  // Factory Pattern.... 'Factory Pattern'
  private queryHandler: QueryHandler = null

  constructor(
    private accesolocalstorage: SecurityService,
    private fb: FormBuilder,
    private rutService: RutService,
    private clog: ConsoleService,
    private clienteProveedorService: ClienteProveedorService,
    private formValidatorsService: FormValidatorsService,
    private toastService: ToastService,
    private vendedorService: VendedorService,
    private messageRendererService: MessageRendererService
  ) {
    this.log = this.clog.log('MODAL-SELECCION-CLIENTES')
  }

  ngOnInit() {
    this.createForm()
    this.rutEmpresa = Number(this.accesolocalstorage.getRutEmpresa());
    this.sucursalCodigo = Number(this.accesolocalstorage.getSucursalCodigo());
    this.paginationContext.RecordsByPage = 10

    this.setQueryHandler()
    this.formChangesSubscriptions()
  }

  formChangesSubscriptions() {
    this.formData.get("rut").valueChanges.subscribe(nombre => {
      if(!nombre)
        return
      this.buscar(1)
    })
  }

  private setQueryHandler() {
    this.onlyRut = this.queryType === QUERY_TYPE.ONLY_RUT || this.queryType === QUERY_TYPE.VENDEDOR || this.queryType === QUERY_TYPE.ONLY_RUT_BLO_DESB

    switch (this.queryType) {
      case QUERY_TYPE.VENDEDOR: {
        this.queryHandler = new QueryHandler(
          this.createInputParamsOnlyRut,
          this.createInputParamsOnlyRutOutside,
          this.vendedorService.obtenerSegunFiltro)
      } break
      default:
        this.queryHandler = new QueryHandler(
          this.createInputParamsRutAndDireccion,
          this.createInputParamsRutAndDireccionOutside,
          this.vendedorService.obtenerSegunFiltro)
        break
    }
  }

  /********* FORM *********/
  private createForm() {
    this.formData = this.fb.group({
      // buscarPor: [this.TIPO_NOMBRE, [Validators.required]],
      // nombre_rut: ['', [Validators.required]]
      codigo: [null, []],
      rut: [null, []],
    });
  }
  /********* FORM *********/

  /********* SHOW/HIDE *********/
  show(config: IModalSeleccionaClienteConfig = this.defaultConfig) {
    this.config = config
    this.cleanAll()
    this.mode = 'SEARCH'
    this.seleccionarClienteModal.show();
    this.buscar(1);
  }

  showSelected(config: IModalSeleccionaClienteConfig = this.defaultConfig) {
    this.cleanAll()
    this.config = config
    this.mode = 'VIEW_SELECTED'

    this.dataSeleccionadaAll.forEach(cliente => {
      cliente.rutFormato = this.rutService.AgregarDV(cliente.rut)
      // cliente.checked = false
      this.removeElementTypename(cliente)
    });

    this.recalculatePageSelectedContext(1)
    // this.paginationContext.RecordsCount = this.dataSeleccionadaAll.length //totalRegistros
    // this.paginationContext.PagesCount = Math.ceil(this.paginationContext.RecordsCount / this.paginationContext.RecordsByPage) //totalPaginas

    // this.log(this.dataSeleccionadaAll)

    this.showPageSelected(1)
    this.seleccionarClienteModal.show();
  }

  hide() {
    this.formData.reset()
    this.seleccionarClienteModal.hide();
  }
  /********* SHOW/HIDE *********/

  /********* OPERATIONS *********/

  private cleanAll() {
    this.cleanFormData()
    this.cleanResultData()
  }

  private cleanFormData() {
    this.formData.reset()
    this.formData.markAsPristine()
    this.formData.markAsUntouched()
    this.initializeFormData()
  }

  private initializeFormData() {
    // this.formData.get("buscarPor").setValue(this.TIPO_NOMBRE)
    // this.formData.get("nombre_rut").setValue('')
    this.formData.get("codigo").setValue(null)
    this.formData.get("rut").setValue(null)
  }

  public cleanResultData() {
    // this.busquedaIniciada = false
    this.dataSeleccionadaAll = [];

    this.data = []
    this.dataAll = []
    this.dataSeleccionada = []
    this.allChecked = false;
    // this.buscar(1);
  }

  // cleanInput() {
  //   // this.formData.get('nombre_rut').setValue('')
  //   this.formData.get('nombre').setValue('')
  //   this.formData.get('rut').setValue('')
  // }

  buscar(pageNumber: number) {

    this.paginationContext.CurrentPage = pageNumber


    this.cleanResultData()

    // const inputParams = this.getInputParams()
    // const inputParams = this.queryHandler.getInputParams()
    const inputParams = this.createInputParams()

    this.loading = true
    this.data = []
    this.dataAll = []

    this.vendedorService.obtenerSegunFiltro(inputParams, result => {
      this.renderQueryResults(result, pageNumber)
    })
  }

  private createInputParams() {
    let rut = 0
    if (this.formData.get('rut').value) {
      rut = this.rutService.Limpiar(this.formData.get('rut').value)
      rut = this.rutService.QuitarDV(rut)
    }

    return {
      entidad: {
        rut_empresa: Number(this.rutEmpresa),
        sucursal_codigo: Number(this.sucursalCodigo),
        tipobusqueda: 1,
        codigo: Number(this.formData.get('codigo').value),
        rut
      },
      paginaActual: 1,
      cantidadRegistrosPorPagina: -1
    }
  }


  /********* CREATE INPUT PARAMS *********/
  private createInputParamsOnlyRut = () => {
    let rut = 0
    if (this.formData.get('rut').value)
      rut = this.rutService.QuitarDV(this.rutService.Limpiar(this.formData.get('rut').value))

    return {
      // nombre: this.formData.get('buscarPor').value === this.TIPO_NOMBRE ? this.formData.get('nombre_rut').value : '',
      // rut: this.formData.get('buscarPor').value === this.TIPO_RUT ? rut : 0,
      nombre: this.formData.get('nombre').value,
      // razon_social: this.formData.get('nombre').value,
      rut,
      busquedaxEstado: 1,
      bloqueado: false,
      es_cliente: true,
      empresa_rut: this.rutEmpresa,
      paginaActual: this.paginationContext.CurrentPage,
      cantidadRegistrosPorPagina: this.paginationContext.RecordsByPage
    }
  }



  private createInputParamsRutAndDireccion = () => {
    let rut = 0
    if (this.formData.get('rut').value)
      rut = this.rutService.QuitarDV(this.rutService.Limpiar(this.formData.get('rut').value))

    return {
      rut,
      nombre: this.formData.get('nombre').value,
      razon_social: this.formData.get('nombre').value,
      rutEmpresa: this.rutEmpresa,
      paginaActual: this.config.paginateLocally ? 1 : this.paginationContext.CurrentPage,
      cantidadRegistrosPorPagina: this.config.paginateLocally ? -1 : this.paginationContext.RecordsByPage
    }
  }

  private createInputParamsOnlyRutTodos = () => {
    let rut = 0
    if (this.formData.get('rut').value)
      rut = this.rutService.QuitarDV(this.rutService.Limpiar(this.formData.get('rut').value))

    return {
      // nombre: this.formData.get('buscarPor').value === this.TIPO_NOMBRE ? this.formData.get('nombre_rut').value : '',
      // rut: this.formData.get('buscarPor').value === this.TIPO_RUT ? rut : 0,
      nombre: this.formData.get('nombre').value,
      // razon_social: this.formData.get('nombre').value,
      rut,
      busquedaxEstado: 3,
      es_cliente: true,
      empresa_rut: this.rutEmpresa,
      paginaActual: this.paginationContext.CurrentPage,
      cantidadRegistrosPorPagina: this.paginationContext.RecordsByPage
    }
  }

  private createInputParamsOnlyRutOutside = (rut) => {
    return {
      nombre: '',
      rut,
      busquedaxEstado: 1,
      bloqueado: false,
      es_cliente: true,
      empresa_rut: this.rutEmpresa,
      paginaActual: 1,
      cantidadRegistrosPorPagina: this.paginationContext.RecordsByPage
    }
  }

  private createInputParamsOnlyRutConDeudaOutside = (rut) => {
    return {
      entidad: {
        empresa_rut: this.rutEmpresa,
        es_cliente: true,
        nombre: '',
        rut
      },
      paginaActual: 1,
      cantidadRegistrosPorPagina: this.paginationContext.RecordsByPage
    }
  }

  private createInputParamsByVendedorOutside = (rut) => {
    return {
      entidad: {
        rut_empresa: this.rutEmpresa,
        sucursal_codigo: this.sucursalCodigo,
        vendedor_codigo: this.vendedorCodigo,
        cliente_proveedor_rut: rut,
        cliente_proveedor_nombre: '',
      },
      paginaActual: 1,
      cantidadRegistrosPorPagina: this.paginationContext.RecordsByPage
    }
  }

  private createInputParamsRutAndDireccionOutside = (rut) => {
    return {
      rut,
      nombre: '',
      rutEmpresa: this.rutEmpresa,
      paginaActual: 1,
      cantidadRegistrosPorPagina: this.paginationContext.RecordsByPage
    }
  }

  private createInputParamsOnlyRutTodosOutside = (rut) => {
    return {
      nombre: '',
      rut,
      busquedaxEstado: 3,
      es_cliente: true,
      empresa_rut: this.rutEmpresa,
      paginaActual: 1,
      cantidadRegistrosPorPagina: this.paginationContext.RecordsByPage
    }
  }
  /********* CREATE INPUT PARAMS *********/


  private renderQueryResults(result: QueryResult, pageNumber: number) {
    const { registros, paginaActual, totalPaginas, totalRegistros } = result

    this.loading = false

    this.dataAll = registros
    this.dataAll.forEach(element => {
      element.rutFormato = this.rutService.AgregarDV(element.rut)
      element.checked = false
      this.removeElementTypename(element)
    });

    this.data = this.dataAll

    if (this.config.paginateLocally) {
      this.paginationContext.RecordsCount = this.dataAll.length //totalRegistros
      this.paginationContext.PagesCount = Math.ceil(this.paginationContext.RecordsCount / this.paginationContext.RecordsByPage) //totalPaginas
      this.paginationContext.CurrentPage = pageNumber
      this.showPage(this.paginationContext.CurrentPage)
    } else {
      this.paginationContext.RecordsCount = this.dataAll.length //totalRegistros
      this.paginationContext.PagesCount = Math.ceil(this.paginationContext.RecordsCount / this.paginationContext.RecordsByPage) //totalPaginas
      this.paginationContext.CurrentPage = pageNumber
      this.showPage(this.paginationContext.CurrentPage)
    }

    this.busquedaIniciada = true
    this.setCheckFromSeleccionados()

    if (this.showInfoClienteInactivoBloqueado) {
      const { nombre, rut } = this.formData.value
      if ((nombre === null || nombre.length === 0) && (rut !== null && rut.length > 0)) {
        this.verifyActivoBloquedAndShowMessage(rut)
      }
    }
  }

  private removeElementTypename(register: any) {
    delete register.__typename
    return register
  }

  private setCheckFromSeleccionados() {
    this.dataSeleccionadaAll.forEach(clienteSeleccionado => {
      this.data
        .filter(cliente => this.match(cliente, clienteSeleccionado))
        .map(cliente => { cliente.checked = true })
    });
  }

  verifyActivoBloquedAndShowMessage(rutConDv: string) {
    let rut = this.rutService.Limpiar(rutConDv)
    rut = this.rutService.QuitarDV(rut)
    const inputParams = {
      entidad: {
        rut,
        empresa_rut: this.rutEmpresa
      }
    }

    this.clienteProveedorService.estadoCliente(inputParams, ({ mensajes, respuesta }) => {
      const ok = mensajes === null && mensajes !== undefined && mensajes.length === 0
      if (!ok) {
        this.messageRendererService.showInfoMessages(mensajes)
        this.messageRendererService.showErrors(mensajes)
        return
      }
    })
  }

  showPage(pageNumber: number) {
    this.paginationContext.CurrentPage = pageNumber
    const start = (this.paginationContext.CurrentPage - 1) * this.paginationContext.RecordsByPage
    this.data = _.slice(this.dataAll, start, start + this.paginationContext.RecordsByPage)
  }

  onPageChange(context: PaginationContext) {
    this.showPage(context.RequestedPage)
  }

  onPageChangeLocal(context: PaginationContext) {
    this.showPage(context.RequestedPage)
  }

  onPageChangeLocalSelected(context: PaginationContext) {
    this.showPageSelected(context.RequestedPage)
  }

  showPageSelected(pageNumber: number) {
    this.paginationContext.CurrentPage = pageNumber
    if (pageNumber > this.paginationContext.PagesCount)
      this.paginationContext.CurrentPage = this.paginationContext.PagesCount
    const start = (this.paginationContext.CurrentPage - 1) * this.paginationContext.RecordsByPage
    this.dataSeleccionada = _.slice(this.dataSeleccionadaAll, start, start + this.paginationContext.RecordsByPage)
  }


  private match(clienteA, clienteB) {
    if (this.onlyRut) {
      return (clienteA.rut === clienteB.rut)
    }

    return (clienteA.rut === clienteB.rut && clienteA.codigo_direccion === clienteB.codigo_direccion)
  }

  checkCliente(cliente) {
    // const { rut, codigo_direccion } = cliente
    // const cliente = this.data.filter(p => p.rut === rut && p.codigo_direccion === codigo_direccion)[0]
    this.toogleCheck(cliente)
    this.handleChecked()

    //  Si check=false
    this.addOrRemoveFromSelected(cliente)

    this.emitirEvento()

    if (this.mode === 'VIEW_SELECTED') {
      this.recalculatePageSelectedContext(this.paginationContext.CurrentPage)
      this.showPageSelected(this.paginationContext.CurrentPage)
    }

    if (this.dataSeleccionadaAll.length === 0)
      this.seleccionarClienteModal.hide()
  }

  addOrRemoveFromSelected(cliente) {
    if (!cliente.checked || this.mode === 'VIEW_SELECTED') {
      //    remover de dataSeleccionada
      this.dataSeleccionadaAll = this.dataSeleccionadaAll.filter(p => !this.match(p, cliente))
    }
    else {
        this.dataSeleccionadaAll.push({ ...cliente })
    }
  }

  recalculatePageSelectedContext(pageNumber: number) {
    this.paginationContext.RecordsCount = this.dataSeleccionadaAll.length //totalRegistros
    this.paginationContext.PagesCount = Math.ceil(this.paginationContext.RecordsCount / this.paginationContext.RecordsByPage) //totalPaginas
    this.paginationContext.CurrentPage = pageNumber
    if (pageNumber > this.paginationContext.PagesCount)
      this.paginationContext.CurrentPage = this.paginationContext.PagesCount
  }

  checkAllChange({ checked }) {
    this.dataAll.forEach((detalle: any) => { detalle.checked = checked })
    this.data.forEach((detalle: any) => { detalle.checked = checked })
    if (!this.dataSeleccionadaAll) this.dataSeleccionadaAll = []

    const _scopeSelected = this.dataAll//.filter((detalle: any) => detalle.checked)
    _scopeSelected.forEach(cliente => {
      this.addOrRemoveFromSelected(cliente)
    });


    this.emitirEvento()
    this.handleChecked()
  }

  private toogleCheck(cliente) {
    cliente.checked = !cliente.checked
  }

  private handleChecked() {
    const checked = this.dataAll.filter(p => p.checked).length
    this.allChecked = this.dataAll.length === checked
  }

  private emitirEvento() {
    // let _data = [...this.data].filter(p => p.checked)
    // this.log('emitir', this.dataSeleccionadaAll)
    this.onSelectMultiple.emit({
      // data: _data,
      data: this.dataSeleccionadaAll,
      origen: this.origen
    })
  }

  selectData(cliente: any) {
    const _cliente = { ...cliente }
    delete _cliente.rutFormato
    delete _cliente.__typename
    this.lastRut = this.rutService.AgregarDV(_cliente.rut)

    if (this.multiple)
      this.dataSeleccionadaAll.push({ ...cliente })

    this.onSelectSingle.emit({
      data: _cliente,
      origen: this.origen
    })
    this.hide()
  }

  public setClientesSeleccionadosFromOutside(clientesSelecionados) {
    this.dataSeleccionadaAll = clientesSelecionados
    this.setCheckFromSeleccionados()
    this.emitirEvento()
  }

  public clearClientesSeleccionadosFromOutside() {
    this.dataSeleccionadaAll = []
  }
  /********* OPERATIONS *********/


  /********* OUTSIDE CALL *********/
  lastRut: string = ''
  rutSearched: string = ''
  // Método para ser consumido desde fuera del componente
  searchByRut(rutConDv: string, deleteSelected: boolean = true) {
    this.rutSearched = rutConDv
    // this.log('lastRut', this.lastRut, 'rutConDv', rutConDv)
    if (this.lastRut !== rutConDv && rutConDv && rutConDv.length > 0 && rutConDv !== '0') {
      this.lastRut = rutConDv
      rutConDv = this.rutService.Limpiar(rutConDv)
      const rut = this.rutService.QuitarDV(rutConDv)

      // Query Local
      const inputParams = this.queryHandler.getInputParamsOnlyRut(rut)
      this.queryHandler.queryData(inputParams, (result) => {
        this.handleResultFromOutterSearch(result)
      })
    }
  }

  private handleResultFromOutterSearch({ totalRegistros, registros }, deleteSelected: boolean = true) {
    // this.log('handleResultFromOutterSearch', this.lastRut, totalRegistros, registros)
    if (totalRegistros === 1) {
      if (deleteSelected)
        this.clearClientesSeleccionadosFromOutside()

      registros[0].checked = true
      registros[0].rutFormato = this.rutService.AgregarDV(registros[0].rut)

      this.removeElementTypename(registros[0])
      this.selectData(registros[0])
    } else {
      if (this.showInfoClienteInactivoBloqueado) {
        this.verifyActivoBloquedAndShowMessage(this.rutSearched)
      }
      this.notFound()
    }
  }

  private notFound() {
    this.onNotFound.emit()
  }
  /********* OUTSIDE CALL *********/

  public cleanLast() {
    this.lastRut = ''
  }

  public setLast(value) {
    this.lastRut = value
  }


}

class QueryHandler {
  public getInputParams: any
  public getInputParamsOnlyRut: any
  public queryData: any

  constructor(
    getInputParams: any,
    getInputParamsOnlyRut: any,
    queryData: any
  ) {
    this.getInputParams = getInputParams
    this.getInputParamsOnlyRut = getInputParamsOnlyRut
    this.queryData = queryData
  }
}
